
export const PaymentCalculator = {
    state: {
        payments: {}
    },
    mutations: {

    },
    actions: {
       
    }
}